<template>
  <div class="wg-testimonial">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <Swiper
            :modules="swiperModules"
            :space-between="0"
            :slides-per-view="1"
            :navigation="{
          nextEl: '.testimonial-next',
          prevEl: '.testimonial-prev',
        }"
            :autoplay="{ delay: 3000, disableOnInteraction: false }" 
          >
            <SwiperSlide
              v-for="(testimonial, index) in testimonials"
              :key="index"
            >
              <div class="testimonial-item">
                <!-- Quote Icon -->
                <img
                  class=""
                  src="assets/images/item-background/icon-quote.png"
                  alt="quote"
                />

                <!-- Testimonial Content -->
                <p class="">{{ testimonial.content }}</p>

                <!-- Rating Stars -->
                <div class="rating ">
                  <i
                    class="icon-star"
                    v-for="star in testimonial.stars"
                    :key="'star-' + star"
                  ></i>
                  <i
                    class="icon-star-empty"
                    v-for="star in 5 - testimonial.stars"
                    :key="'empty-' + star"
                  ></i>
                </div>

                <!-- Author -->
                <div class="author">
                  <a href="#">{{ testimonial.name }}</a>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
        <div class="swiper-button-next testimonial-next style-arrow-default"></div>
                    <div class="swiper-button-prev testimonial-prev style-arrow-default"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Autoplay } from "swiper/modules"; // ✅ add Autoplay
import "swiper/css";
import "swiper/css/navigation";
import axios from "axios";

export default {
  name: "TestimonialComponent",
  components: { Swiper, SwiperSlide },
  data() {
    return {
      testimonials: [],
      swiperModules: [Navigation, Autoplay], // ✅ include autoplay
    };
  },
  mounted() {
    this.fetchTestimonials();
  },

  methods: {
     async fetchTestimonials() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/review`);

        this.testimonials = response.data;
      } catch (error) {
        console.error("There was an error fetching the data:", error);
        this.$emitContentReady(); // still hide preload
      }
    },
  },
};
</script>

<style scoped>
.swiper-navigation-icon {
  display: none !important;
}
</style>
